
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("kNekD", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.2603113a.js.map
